"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Retrieve = void 0;
var expression_1 = require("./expression");
var util_1 = require("../util/util");
var builder_1 = require("./builder");
var Retrieve = /** @class */ (function (_super) {
    __extends(Retrieve, _super);
    function Retrieve(json) {
        var _this = _super.call(this, json) || this;
        _this.datatype = json.dataType;
        _this.templateId = json.templateId;
        _this.codeProperty = json.codeProperty;
        _this.codes = (0, builder_1.build)(json.codes);
        _this.dateProperty = json.dateProperty;
        _this.dateRange = (0, builder_1.build)(json.dateRange);
        return _this;
    }
    Retrieve.prototype.exec = function (ctx) {
        var _a;
        var _this = this;
        // Object with retrieve information to pass back to patient source
        // Always assign datatype. Assign codeProperty and dateProperty if present
        var retrieveDetails = __assign(__assign({ datatype: this.datatype }, (this.codeProperty ? { codeProperty: this.codeProperty } : {})), (this.dateProperty ? { dateProperty: this.dateProperty } : {}));
        if (this.codes) {
            var resolvedCodes = this.codes.execute(ctx);
            if (resolvedCodes == null) {
                return [];
            }
            retrieveDetails.codes = resolvedCodes;
        }
        if (this.dateRange) {
            retrieveDetails.dateRange = this.dateRange.execute(ctx);
        }
        if (this.templateId) {
            retrieveDetails.templateId = this.templateId;
        }
        var records = ctx.findRecords(this.templateId != null ? this.templateId : this.datatype, retrieveDetails);
        if (retrieveDetails.codes) {
            records = records.filter(function (r) { return _this.recordMatchesCodesOrVS(r, retrieveDetails.codes); });
        }
        if (retrieveDetails.dateRange && this.dateProperty) {
            records = records.filter(function (r) { var _a; return (_a = retrieveDetails.dateRange) === null || _a === void 0 ? void 0 : _a.includes(r.getDateOrInterval(_this.dateProperty)); });
        }
        if (Array.isArray(records)) {
            (_a = ctx.evaluatedRecords).push.apply(_a, records);
        }
        else {
            ctx.evaluatedRecords.push(records);
        }
        return records;
    };
    Retrieve.prototype.recordMatchesCodesOrVS = function (record, codes) {
        var _this = this;
        if ((0, util_1.typeIsArray)(codes)) {
            return codes.some(function (c) { return c.hasMatch(record.getCode(_this.codeProperty)); });
        }
        else {
            return codes.hasMatch(record.getCode(this.codeProperty));
        }
    };
    return Retrieve;
}(expression_1.Expression));
exports.Retrieve = Retrieve;
//# sourceMappingURL=external.js.map